import { put, call } from 'redux-saga/effects';
import { SignupCodesAction, UIAction } from '../actions';
import { SignupCodesService } from '../services';
import { generateReadableError } from 'hooks';
import { uiEffect } from './saga.hooks';

export function* getCodes(action) {
  yield put(UIAction.showLoading(true));
  yield put(SignupCodesAction.getCodesSuccess(null));
  try {
    const { data } = yield call(SignupCodesService.getInstance().getCodes, action.payload);
    yield put(SignupCodesAction.getCodesSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield* uiEffect(generateReadableError(e), false);
  }
}

export function* saveCode(action) {
  yield* uiEffect(null, true);
  yield put(SignupCodesAction.saveCodeSuccess(null));
  try {
    let result;
    if(action.payload && action.payload.id){
      result = yield call(SignupCodesService.getInstance().updateCode, action.payload);
    }else{
      result = yield call(SignupCodesService.getInstance().createCode, action.payload);
    }
    console.log('result', result)
    yield put(SignupCodesAction.saveCodeSuccess(result.data));
    yield* uiEffect({ status: 'success', message: result.data.responseMessage }, false);
  }
  catch (e) {
    yield* uiEffect(generateReadableError(e), false);
  }
}

export function* deleteCode(action) {
  yield* uiEffect(null, true);
  yield put(SignupCodesAction.deleteCodeSuccess(null));
  try {
    const { data } = yield call(SignupCodesService.getInstance().deleteCode, action.payload);
    yield put(SignupCodesAction.deleteCodeSuccess(data));
    yield* uiEffect({ status: 'success', message: data.responseMessage }, false);
  }
  catch (e) {
    yield* uiEffect(generateReadableError(e), false);
  }
}









